import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
const isSection = (entry)=>'header' in entry;
export function toMenuItems(entries, testIds, pick) {
    return entries.map((entry)=>{
        if (isSection(entry)) {
            const { id, header, testId } = entry;
            return {
                id,
                isSectionHeader: true,
                label: header,
                testId: testId !== null && testId !== void 0 ? testId : testIds.Section(id)
            };
        }
        const { id, title, testId, token } = entry, bi = _object_without_properties(entry, [
            "id",
            "title",
            "testId",
            "token"
        ]);
        return _object_spread_props(_object_spread({}, bi), {
            id,
            title,
            lightTitle: true,
            testId: testId !== null && testId !== void 0 ? testId : testIds.Item(token),
            onClick: ()=>pick(token)
        });
    });
}
export function closingFooterItems(items, onClose) {
    return items.map((item)=>{
        const onClick = ()=>{
            var _item_props_onClick, _item_props;
            onClose();
            (_item_props_onClick = (_item_props = item.props).onClick) === null || _item_props_onClick === void 0 ? void 0 : _item_props_onClick.call(_item_props);
        };
        return item.variant === 'promotionalAction' ? {
            variant: 'promotionalAction',
            props: _object_spread_props(_object_spread({}, item.props), {
                onClick
            })
        } : {
            variant: 'contextualAction',
            props: _object_spread_props(_object_spread({}, item.props), {
                onClick
            })
        };
    });
}
